import { initialTrackerState } from "store/initialStates";
import { ReducersInterfaceAction } from "types/Reducers";
import { TrackerState } from "types/Tracker";
import { TrackerConstants } from "constants/constants";

export const trackerReducer = (
  state = initialTrackerState,
  action: ReducersInterfaceAction,
): TrackerState => {
  switch (action.type) {
    case TrackerConstants.TRACKER_PAGE_GET_DATA_SUCCESS:
      return {
        ...state,
        loadingData: false,
        dataList: action.payload?.dataList,
      };
    case TrackerConstants.TRACKER_PAGE_GET_DATA_LOADING:
      return {
        ...state,
        loadingData: true,
      };
    case TrackerConstants.TRACKER_PAGE_GET_DATA_ERROR:
      return {
        ...state,
        loadingData: false,
      };
    case TrackerConstants.TRACKER_PAGE_CHANGE_STATION:
      return {
        ...state,
        trackerFilters: action.payload,
      };
    case TrackerConstants.TRACKER_PAGE_CHANGE_DATE:
      return {
        ...state,
        trackerFilters: { ...state.trackerFilters, date: {...state.trackerFilters.date, week: action.payload }},
      };
    case TrackerConstants.TRACKER_PAGE_SET_FILTERS:
      return {
        ...state,
        trackerFilters: {
          ...state.trackerFilters,
          ...action.payload,
        },
      };
    case TrackerConstants.TRACKER_PAGE_CHANGE_TABLE_SORT:
      return {
        ...state,
        trackerFilters: {
          ...state.trackerFilters,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
